import { createApp } from "vue";
/* eslint-disable */

import vSelect from "vue-select";

import router from "./router.js";
import store from "./store/index.js";
import App from "./App.vue";
import Editor from "@tinymce/tinymce-vue";

import VueApexCharts from "vue3-apexcharts";

import { quillEditor, Quill } from "vue3-quill";
import getPlaceholderModule from "quill-placeholder-module";

import VTooltip from "v-tooltip";
import "v-tooltip/dist/v-tooltip.css";

import PrimeVue from "primevue/config";
import { FilterMatchMode, FilterService } from "primevue/api";

import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "primeflex/primeflex.min.css";

import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import "./hooks/consoleLog.js";
import "./hooks/priceFix.js";
import "./hooks/dateCVFix.js";
import Tooltip from "primevue/tooltip";

const BaseCard = () => import("./components/UI/BaseCard.vue");

const app = createApp(App);

Quill.register(
  "modules/placeholder",
  getPlaceholderModule(Quill, {
    className: "ql-placeholder-content", // default
  })
);

FilterService.register("filterByDateRange", (date, range) => {
  if (!range || range == "" || range[0] == null || range[0] == "") {
    return true;
  }
  var date_fix = date.split("/");
  date_fix = new Date(date_fix[2], date_fix[1] - 1, date_fix[0]);
  if (range[1] == null) {
    var range0_tmp = new Date(range[0]);
    return date_fix.getTime() === range0_tmp.getTime();
  }
  var range0_tmp2 = new Date(range[0]);
  var range1_tmp2 = new Date(range[1]);
  return (
    date_fix.getTime() >= range0_tmp2.getTime() &&
    date_fix.getTime() <= range1_tmp2.getTime()
  );
});

app.use(store);
app.use(router);
app.use(VueApexCharts);
app.use(VTooltip);
app.use(quillEditor);
app.use(BootstrapVue3);
app.use(PrimeVue, {
  ripple: true,
  locale: {
    startsWith: "Inizia con",
    contains: "Contiene",
    notContains: "Non contiene",
    endsWith: "Finisce con",
    equals: "Uguale a",
    notEquals: "Diverso da",
    noFilter: "Nessuno",
    lt: "Minore di",
    lte: "Minore o uguale a",
    gt: "Maggiore di",
    gte: "Maggiore o uguale a",
    dateIs: "Il giorno",
    dateIsNot: "Tranne il giorno",
    dateBefore: "Dopo il",
    dateAfter: "Prima del",
    clear: "Rimuovi",
    apply: "Applica",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Aggiungi filtro",
    removeRule: "Rimuovi filtro",
    accept: "Si",
    reject: "No",
    choose: "Scegli",
    upload: "Carica",
    cancel: "Cancella",
    dayNames: [
      "Lunedì",
      "Martedì",
      "Mercoledì",
      "Venerdì",
      "Sabato",
      "Domenica",
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    today: "Oggi",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    dateFormat: "dd/mm/yy",
    weak: "Debole",
    medium: "Medio",
    strong: "Forte",
    passwordPrompt: "Inserire una password",
    emptyFilterMessage: "Nessun risultato",
    emptyMessage: "Nessuna opzione disponibile",
  },
  filterMatchModeOptions: {
    text: [
      FilterMatchMode.STARTS_WITH,
      FilterMatchMode.CONTAINS,
      FilterMatchMode.NOT_CONTAINS,
      FilterMatchMode.ENDS_WITH,
      FilterMatchMode.EQUALS,
      FilterMatchMode.NOT_EQUALS,
    ],
    numeric: [
      FilterMatchMode.EQUALS,
      FilterMatchMode.NOT_EQUALS,
      FilterMatchMode.LESS_THAN,
      FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
      FilterMatchMode.GREATER_THAN,
      FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
    ],
    date: [
      FilterMatchMode.DATE_IS,
      FilterMatchMode.DATE_IS_NOT,
      FilterMatchMode.DATE_BEFORE,
      FilterMatchMode.DATE_AFTER,
      "filterByDateRange",
    ],
  },
});

app.component("editor", Editor);

app.component("base-card", BaseCard);
app.component("VueDatePicker", VueDatePicker);
// app.component("apexchart", VueApexCharts);
app.component("v-select", vSelect);

/** PRIME VUE COMPONENTS */

import AutoComplete from "primevue/autocomplete";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import VirtualScroller from "primevue/virtualscroller";
import Avatar from "primevue/avatar";
import AvatarGroup from "primevue/avatargroup";
import Badge from "primevue/badge";
import Button from "primevue/button";
import Breadcrumb from "primevue/breadcrumb";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Carousel from "primevue/carousel";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import Chips from "primevue/chips";
import ColorPicker from "primevue/colorpicker";
import Column from "primevue/column";
import CascadeSelect from "primevue/cascadeselect";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmationService from "primevue/confirmationservice";
import ContextMenu from "primevue/contextmenu";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Dropdown from "primevue/dropdown";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
import Image from "primevue/image";
import InlineMessage from "primevue/inlinemessage";
import Inplace from "primevue/inplace";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import TriStateCheckbox from "primevue/tristatecheckbox";
import InputText from "primevue/inputtext";
import Knob from "primevue/knob";
import Galleria from "primevue/galleria";
import Listbox from "primevue/listbox";
import MegaMenu from "primevue/megamenu";
import Menu from "primevue/menu";
import Menubar from "primevue/menubar";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import OrderList from "primevue/orderlist";
import OrganizationChart from "primevue/organizationchart";
import Chart from "primevue/chart";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Panel from "primevue/panel";
import PanelMenu from "primevue/panelmenu";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import Rating from "primevue/rating";
import RadioButton from "primevue/radiobutton";
import SelectButton from "primevue/selectbutton";
import ScrollPanel from "primevue/scrollpanel";
import ScrollTop from "primevue/scrolltop";
import Slider from "primevue/slider";
import Sidebar from "primevue/sidebar";
import Skeleton from "primevue/skeleton";
import SplitButton from "primevue/splitbutton";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Steps from "primevue/steps";
import TabMenu from "primevue/tabmenu";
import Tag from "primevue/tag";
import TieredMenu from "primevue/tieredmenu";
import Textarea from "primevue/textarea";
import Timeline from "primevue/timeline";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Toolbar from "primevue/toolbar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ToggleButton from "primevue/togglebutton";
import Tree from "primevue/tree";
import TreeSelect from "primevue/treeselect";
import TreeTable from "primevue/treetable";
import StyleClass from "primevue/styleclass";
import Ripple from "primevue/ripple";
import BadgeDirective from "primevue/badgedirective";

app.directive("badge", BadgeDirective);
app.directive("styleclass", StyleClass);
app.directive("ripple", Ripple);

app.use(ConfirmationService);
app.use(ToastService);

app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("VirtualScroller", VirtualScroller);
app.component("AutoComplete", AutoComplete);
app.component("Avatar", Avatar);
app.component("AvatarGroup", AvatarGroup);
app.component("Badge", Badge);
app.component("Breadcrumb", Breadcrumb);
app.component("Button", Button);
app.component("Calendar", Calendar);
app.component("CascadeSelect", CascadeSelect);
app.component("Card", Card);
app.component("Carousel", Carousel);
app.component("Checkbox", Checkbox);
app.component("Chip", Chip);
app.component("Chips", Chips);
app.component("ColorPicker", ColorPicker);
app.component("Column", Column);
app.component("ConfirmDialog", ConfirmDialog);
app.component("ConfirmPopup", ConfirmPopup);
app.component("ContextMenu", ContextMenu);
app.component("DataTable", DataTable);
app.component("DataView", DataView);
app.component("DataViewLayoutOptions", DataViewLayoutOptions);
app.component("Dialog", Dialog);
app.component("Divider", Divider);
app.component("Dropdown", Dropdown);
app.component("Fieldset", Fieldset);
app.component("FileUpload", FileUpload);
app.component("Image", Image);
app.component("InlineMessage", InlineMessage);
app.component("Inplace", Inplace);
app.component("InputMask", InputMask);
app.component("InputNumber", InputNumber);
app.component("InputSwitch", InputSwitch);
app.component("TriStateCheckbox", TriStateCheckbox);
app.component("InputText", InputText);
app.component("Galleria", Galleria);
app.component("Knob", Knob);
app.component("Listbox", Listbox);
app.component("MegaMenu", MegaMenu);
app.component("Menu", Menu);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Menubar", Menubar);
app.component("Message", Message);
app.component("MultiSelect", MultiSelect);
app.component("OrderList", OrderList);
app.component("OrganizationChart", OrganizationChart);
app.component("Chart", Chart);
app.component("OverlayPanel", OverlayPanel);
app.component("Paginator", Paginator);
app.component("Panel", Panel);
app.component("PanelMenu", PanelMenu);
app.component("Password", Password);
app.component("PickList", PickList);
app.component("ProgressBar", ProgressBar);
app.component("RadioButton", RadioButton);
app.component("Rating", Rating);
app.component("SelectButton", SelectButton);
app.component("ScrollPanel", ScrollPanel);
app.component("ScrollTop", ScrollTop);
app.component("Slider", Slider);
app.component("Sidebar", Sidebar);
app.component("Skeleton", Skeleton);
app.component("SplitButton", SplitButton);
app.component("Splitter", Splitter);
app.component("SplitterPanel", SplitterPanel);
app.component("Steps", Steps);
app.component("TabMenu", TabMenu);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Tag", Tag);
app.component("Textarea", Textarea);
app.component("TieredMenu", TieredMenu);
app.component("Timeline", Timeline);
app.component("Toast", Toast);
app.component("Toolbar", Toolbar);
app.component("ToggleButton", ToggleButton);
app.component("Tree", Tree);
app.component("TreeSelect", TreeSelect);
app.component("TreeTable", TreeTable);

app.mount("#app");

// console.clear();
// console.log(`   ******   **                       **          **  **  **
// **////** /**                      /**         //  /** /**            *****
// **    //  /**  ******  **   **     /** **    ** ** /** /**  ******   **///**  *****
// /**        /** **////**/**  /**  ******/**   /**/** /** /** //////** /**  /** **///**
// /**        /**/**   /**/**  /** **///**//** /** /** /** /**  ******* //******/*******
// //**    ** /**/**   /**/**  /**/**  /** //****  /** /** /** **////**  /////**/**////
// //******  ***//****** //******//******  //**   /** *** ***//********  ***** //******
// //////  ///  //////   //////  //////    //    // /// ///  ////////  /////   //////

//                            ******  *******   ****     ****
//                           **////**/**////** /**/**   **/**
//                          **    // /**   /** /**//** ** /**
//                         /**       /*******  /** //***  /**
//                         /**       /**///**  /**  //*   /**
//                         //**    **/**  //** /**   /    /**
//                          //****** /**   //**/**        /**
//                           //////  //     // //         //

//                **                   *******
//               /**       **   **    /**////**
//               /**      //** **     /**    /**  ******    *****   ******   ******
//               /******   //***      /**    /** //////**  **///** **////** **////
//               /**///**   /**       /**    /**  ******* /**  // /**   /**//*****
//               /**  /**   **        /**    **  **////** /**   **/**   /** /////**
//               /******   **         /*******  //********//***** //******  ******
//               /////    //          ///////    ////////  /////   //////  //////     `)

var godMode = [];
var godModeON = false;

document.addEventListener("keyup", (e) => {
  if (godModeON) {
    switch (godMode.length) {
      case 0:
        if (e.code === "Escape") {
          godMode.push(e.code);
        }
        break;
      case 1:
        if (e.code === "Escape") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 2:
        if (e.code === "Escape") {
          document.body.contentEditable = false;
          // console.log("CHEAT: God Mode Deactivated");
          godModeON = false;
        }
        godMode = [];
        break;
    }
  } else {
    switch (godMode.length) {
      case 0:
        if (e.code === "KeyX") {
          godMode.push(e.code);
        }
        break;
      case 1:
        if (e.code === "KeyX") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 2:
        if (e.code === "KeyV") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 3:
        if (e.code === "KeyO") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 4:
        if (e.code === "ArrowUp") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 5:
        if (e.code === "ArrowDown") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 6:
        if (e.code === "ArrowRight") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 7:
        if (e.code === "ArrowLeft") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 8:
        if (e.code === "ArrowRight") {
          godMode.push(e.code);
        } else {
          godMode = [];
        }
        break;
      case 9:
        if (e.code === "ArrowRight") {
          document.body.contentEditable = true;
          // console.log("CHEAT: God Mode Activated");
          godModeON = true;
        }
        godMode = [];
        break;
    }
  }
});
